export interface RegistrationChoiceOption {
  value: string;
  label: string;
}

type ChoiceOptionsByField = Record<string, readonly RegistrationChoiceOption[]>;
type ChoiceAliasesByField = Record<string, Record<string, string>>;

export function normalizeRegistrationChoice(
  value: unknown,
  options: readonly RegistrationChoiceOption[],
  aliases: Record<string, string> = {},
): unknown {
  if (value === null || value === undefined || value === '') return value;

  const normalizedValue = String(value).trim();
  const lookupValue = normalizedValue.toLocaleLowerCase();
  const matchingOption = options.find((option) => (
    option.value.toLocaleLowerCase() === lookupValue
      || option.label.trim().toLocaleLowerCase() === lookupValue
  ));

  return matchingOption?.value ?? aliases[lookupValue] ?? normalizedValue;
}

export function normalizeExtractedRegistrationChoices<T extends Record<string, unknown>>(
  data: T,
  optionsByField: ChoiceOptionsByField,
  aliasesByField: ChoiceAliasesByField = {},
): T {
  const normalizedData = { ...data };

  Object.entries(optionsByField).forEach(([fieldName, options]) => {
    if (!(fieldName in normalizedData)) return;
    normalizedData[fieldName as keyof T] = normalizeRegistrationChoice(
      normalizedData[fieldName],
      options,
      aliasesByField[fieldName],
    ) as T[keyof T];
  });

  return normalizedData;
}
